module.exports = __webpack_public_path__ + "static/android-2ea15fc52a2d10e2dc757c2fbfb1a79a.png";